
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex flex-col items-center justify-center bg-navy-dark text-foreground py-20">
        <div className="container mx-auto text-center">
          <h1 className="text-8xl font-bold mb-6 text-rust">404</h1>
          <p className="text-2xl md:text-4xl font-semibold mb-4">Strona nie została odnaleziona</p>
          <p className="text-lg text-steel-light mb-8 max-w-md mx-auto">
            Przepraszamy, ale strona, której szukasz, nie istnieje lub została przeniesiona.
          </p>
          <div className="flex justify-center">
            <Button asChild className="bg-rust hover:bg-rust-dark">
              <Link to="/">Wróć do strony głównej</Link>
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
